import { AxiosPromise } from 'axios';
import { BillboardDistributionModel } from '../models/distributionModels';
import api from './api';

export function createBillboardAssignments(assignmentCriteria: BillboardDistributionModel) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.post('/billboard-assignments', assignmentCriteria)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getBillboardAssignments() {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.get('/billboard-assignments')
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
